import React, { memo } from "react";
export default memo(({ data }) => {
  return (
    <>
      <div className={`flow-node-container`}>{data.label}</div>
    </>
  );
});
